
var polarisList = ( function ( $, polarisList ) {
    'use strict';

    var $filterContent;

    polarisList.filter = function()
    {
        $filterContent = $('[data-filter-content]');

        $(document).on('click', '.Polaris-Backdrop--transparent', function(ev) {
            ev.preventDefault();
            $('[data-filter-close-btn]').click();
        });

        $(document).on('click', '[data-filter-close-btn]', function(ev) {
            ev.preventDefault();
            $('[data-filter-content]').hide();
        });

        if($('.filter-group-hidden').length){
            $('[data-filter-show-hidden-btn]').show();
        }

        $(document).on('click', '[data-filter-show-hidden-btn]', function(ev) {
            ev.preventDefault();
            let $button = $(ev.currentTarget);
            let type = '';
            if($button.hasClass('opened')){
                type = 'close';
                $button.removeClass('opened');
                $(this).text($(this).data('textOpen'));
            } else {
                type = 'open';
                $button.addClass('opened');
                $(this).text($(this).data('textClose'));
            }
            $('.filter-group-hidden [data-filter-group-label]').trigger('click', [type]);
        });

        $(document).on('click', '[data-filter-group-label]', function(ev, type) {
            const button = $(this);
            const open = button.data('filterGroupLabel') === 'open';
            const $itemContent = $(this).closest('[data-filter-group-content]');
            const $content = $itemContent.children('[data-filter-group-label-content]').first();

            if ((type === 'open' && open) || (type === 'close' && !open)) {
                return;
            }

            button.data('filterGroupLabel', open ? 'close' : 'open');

            $content.slideToggle();
            if(button.closest('.filter-group-hidden').length){
                return;
            }
            button.find('[data-filter-item-icon-down]').toggle();
            button.find('[data-filter-item-icon-up]').toggle();
        });

        $(document).on('click', '[data-filter-item-label]', function(ev) {
            ev.preventDefault();
            var $itemContent = $(this).closest('[data-filter-item-content]');
            var $elementsContent = $itemContent.find('[data-filter-item-element-content]');
            var $elementContent = $elementsContent.find('[data-ajax-filter-element-url]');

            let ajaxUrlElement = $elementContent.data('ajax-filter-element-url');

            // open with ajax
            if (ajaxUrlElement) {

                $elementContent.html(' <img width="15" height="15" src="/images/ajax-loader.gif" />');
                $elementsContent.slideToggle();
                $itemContent.find('[data-filter-item-icon-down]').toggle();
                $itemContent.find('[data-filter-item-icon-up]').toggle();

                $.ajax({
                    url: ajaxUrlElement,
                    success: function(data) {
                        $elementContent.data('ajax-filter-element-url', null);
                        $elementContent.html(data.html);

                        window.chosenLoad();
                        window.select2Init();
                    }
                });
            } else {
                $elementsContent.slideToggle();
                $itemContent.find('[data-filter-item-icon-down]').toggle();
                $itemContent.find('[data-filter-item-icon-up]').toggle();
            }
        });

        $(document).on('click', '[data-filter-btn]', function(ev) {
            ev.preventDefault();
            $('[data-filter-content]').show();
        });

        $(document).on('click', '[data-search-btn]', function(ev) {
            ev.preventDefault();
            $('.datagrid-search-btn').hide();
            $('.datagrid-search-input').show();
            $('.datagrid-search-input input').focus();
        });

        $(document).on('keypress', '[data-search-input]', function(ev) {
            if (ev.which === 13) {
                let filter = $('[data-list-filter]');
                filter.find('input[name="fulltext"]').val($(this).val());
                filter.submit();
            }
        })

        $(document).on('click', '[data-filter-multiple-select-all]', function() {
            var $row = $(this).closest('[data-filter-item-content]');
            if ($row.is('.active')) {
                $row.removeClass('active');
            }
            else {
                $row.addClass('active');
            }
            $row.find('option').prop('selected', $row.is('.active')).parent().trigger('chosen:updated');
        });
    };

    polarisList.clearSelectMemmory = function() {
        var $headerSelect = $('[data-index-select-header]');
        $headerSelect.data('values', {});
    };

    polarisList.showSelectControlPanel = function() {
        var $headerSelect = $('[data-index-select-header]');
        var $headerNoSelect = $('[data-index-no-select-header]');
        var data = $headerSelect.data('values');

        // zobrazíme dle toho jestli jsou nějaké řádky označené
        if (Object.keys(data).length) {
            $headerSelect.show();
            // $headerNoSelect.hide();
            $headerNoSelect.closest('.Polaris-IndexTable').find('.Polaris-IndexTable__Table').addClass('Polaris-IndexTable--selectMode');

            var count = 0;
            $.each(data, function(key, values) {
                count = count + Object.keys(values).length;
            });
            $headerSelect.find('.Polaris-CheckableButton__Label span').text(count);
        }
        else {
            $headerSelect.hide();
            // $headerNoSelect.show();
            $headerNoSelect.closest('.Polaris-IndexTable').find('.Polaris-IndexTable__Table').removeClass('Polaris-IndexTable--selectMode');
        }
    };

    // pro uložení mezi stránkama ukládáme do localstorage následně načteme pomocí polarisList.loadSelectedRows
    polarisList.saveSelectedRows = function() {
        var $headerSelect = $('[data-index-select-header]');
        // pokud neexistuji data z předchozí stránky, tak vytvoříme prázný object
        if (typeof $headerSelect.data('values') !== "undefined") {
            window.localStorage.setItem('select-values', JSON.stringify($headerSelect.data('values')));
        }
    };

    polarisList.loadSelectedRows = function() {
        // pokud máme něco v LocalStorage, tak zobrazíme a odstraníme z localstorege
        var $headerSelect = $('[data-index-select-header]');
        var $selectValue = window.localStorage.getItem('select-values');
        if ($selectValue) {
            var data = JSON.parse($selectValue);
            $headerSelect.data('values', data);
            polarisList.showSelectControlPanel();

            $('.Polaris-IndexTable__TableRow--selected').removeClass('Polaris-IndexTable__TableRow--selected');
            // pokud jsou uložené i data na stránce tak checkboxy nastavíme na checked
            $.each(data, function(key, values) {
                $.each(values, function(k, k2) {
                    $('[data-index-select-checkbox-item][name="' + key + '"][value="' + k2 + '"]').prop('checked', true).closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
                });
            });

            window.localStorage.removeItem('select-values')
        }
    };

    polarisList.checkSelectedRow = function() {
        var $selectedRow = $('[data-index-select-checkbox-item]:checked');
        var $noSelectedRow = $('[data-index-select-checkbox-item]:not(:checked)');
        var $headerNoSelect = $('[data-index-no-select-header]');
        var $headerSelect = $('[data-index-select-header]');

        // pokud neexistuji data z předchozí stránky, tak vytvoříme prázný object
        if (typeof $headerSelect.data('values') === "undefined") {
            $headerSelect.data('values', {});
        }

        var data = $headerSelect.data('values');

        $('.Polaris-IndexTable__TableRow--selected').removeClass('Polaris-IndexTable__TableRow--selected');

        // ty které jsou selected, přidáme do pole
        $selectedRow.each(function(i, el) {
            var $el = $(el);
            if (typeof data[$el.attr('name')] === 'undefined') {
                data[$el.attr('name')] = {};
            }
            data[$el.attr('name')][$el.val()] = $el.val();

            $el.closest('tr').addClass('Polaris-IndexTable__TableRow--selected');
        });


        // ty které nejsou na stránce selected odebereme z pole
        $noSelectedRow.each(function(i, el) {
            var $el = $(el);

            if (typeof data[$el.attr('name')] === "undefined") {

            }
            else if (typeof data[$el.attr('name')][$el.val()] !== "undefined") {
                delete data[$el.attr('name')][$el.val()];
            }
            else if (Object.keys(data[$el.attr('name')]).length === 0) {
                delete data[$el.attr('name')];
            }
        });


        // nastavíme data k hromadným akcím
        $('[data-index-select-action-item] [data-action-type]').each(function(i, el) {
            var $el = $(el);
            if ($el.data('action-type') === 'modal') {
                $el.data('values', data);
            }
        });

        // uložíme si, abychom mohl v případě stránkování uchovat ID produktu
        $headerSelect.data('values', data);

        // pokud jsou nějaké selected, tak zobrazíme panel
        polarisList.showSelectControlPanel();
    };

    polarisList.initialize = function()
    {
        polarisList.filter();

        $('[data-list-page-limit]').on('click', function(e) {
            var url = new URL(window.location.href);
            url.searchParams.set('limit', $(this).attr('data-list-page-limit'));
            window.location.href = url.href;
        });

        // klik na checkbox na řádku
        $('[data-index-select-checkbox-item]').on('change', function() {
            polarisList.checkSelectedRow();
        });

        var $jobsContent = $('[data-jobs-content]');
        if ($jobsContent.length) {
            var checkJobs = function() {
                var isDropdownOpen = $('[data-datagrid-job-dropdown]').is('.show');

                $.ajax({
                    url: $jobsContent.data('jobs-url'),
                    success: function(data) {
                        if (data.html) {
                            $jobsContent.html(data.html);
                            if (isDropdownOpen) {
                                $('[data-datagrid-job-btn]').click();
                            }
                        } else {
                            $jobsContent.html('');
                            clearInterval(jobInterval);
                        }
                    }
                });
            };
            var jobInterval = setInterval(checkJobs, 5000);
        }

        // klik na checkbox v hlavičce (označut vše)
        $('[data-index-select-checkbox-all]').on('change', function() {
            $('[data-index-select-checkbox-item]').prop('checked', true);
            $(this).prop('checked', false);
            polarisList.checkSelectedRow();
        });

        // click na selected checkbox v hlavičce (zrušit označené)
        $('[data-index-select-selected-content]').on('click', function() {
            $('[data-index-select-checkbox-item]').prop('checked', false);
            polarisList.clearSelectMemmory();
            polarisList.checkSelectedRow();
        });

        // click na selected checkbox v hlavičce (zrušit označené)
        $('[data-index-select-all-content] button').on('click', function(ev) {
            ev.preventDefault();
            var $this = $(this);
            var $headerSelect = $('[data-index-select-header]');
            $.ajax({
                url: $this.data('index-select-all-url'),
                success: function(data) {
                    $headerSelect.data('values', data.result);
                    $headerSelect.find('.Polaris-CheckableButton__Label span').text(data.count);
                    $('[data-index-select-checkbox-item]').prop('checked', true);
                    $('[data-index-select-action-item] [data-action-type]').each(function(i, el) {
                        var $el = $(el);
                        if ($el.data('action-type') === 'modal') {
                            $el.data('values', data.result);
                        }
                    });
                }
            });
        });

        $('.page-link, [data-list-page-limit]').on('click', function() {
            polarisList.saveSelectedRows();
        });
        polarisList.loadSelectedRows();

        // pokud existují checkboxy, tak pošleme požadavek na všechny položky a necháme uložit do cache
        if ($('[data-index-select-all-url]').length) {
            $.ajax({
                url: $('[data-index-select-all-url]').data('index-select-all-url'),
                success: function(data) {

                }
            });
        }
    };

    return polarisList;
}( window.jQuery, polarisList || { } ) );

window.polarisList = polarisList;

$(document).ready(function() {
    let hash = window.location.hash ? window.location.hash.replace('#', '') : '';
    switch(hash) {
        case 'translated':
            window.setTimeout(function() {
                selectAllProducts(translateAll);
            }, 500);
            break;
        case 'rated':
            window.setTimeout(function() {
                selectAllProducts(rateAll);
            }, 500);
            break;
        case 'exported':
            window.setTimeout(function() {
                selectAllProducts(exportAll);
            }, 500);
            break;

    }

    function selectAllProducts(next) {
        $('[data-index-no-select-header] input[name="select-all"]').trigger('click');
        window.setTimeout(function() {
            $('[data-index-select-all-url]').trigger('click');
            window.setTimeout(next, 1000);
        }, 500);
    }

    function translateAll() {
        $('[data-index-select-header] a[href*="product\/translate"]:first').trigger('click');
    }

    function rateAll() {
        $('[data-index-select-header] a[href*="translation-quality"]:first').trigger('click');
    }

    function exportAll() {
        $('[data-index-select-header] a[href*="product\/listed"]:first').trigger('click');
    }
});
